export enum ImageViewerCloseRoleEnum {
	BUTTON = 'button',
	BACKDROP = 'backdrop',
	KEYBOARD = 'keyboard',
}

export type ImageViewerCloseRoleEnumValues = `${ImageViewerCloseRoleEnum}`;
